import React, {
  useState,
} from 'react';
import { withStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import PropTypes from 'prop-types';
import useMetaLayoutContext from 'Components/UI/Meta/MetaForm/Components/MetaLayoutContext';
import RoundedButton from 'Components/ComponentLibrary/Components/Uncategorized/RoundedButton';

import RemainingFieldList from 'Components/UI/Meta/MetaForm/Components/MetaLayout/RemainingFieldList';
import { useFooterContext } from 'Context/FooterContext';
import Portal from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/Portal';
import BaseFormLayout from 'Components/ComponentLibrary/Templates/Unauthenticated/Content/BaseFormLayout';
import { useNewLoginContext } from '../../../NewLoginContext';

const styles = () => ({
  root: {},
  fields: {},
});

function DefaultLayout({
  classes,
}) {
  const { resource, onSubmit, unsourcedErrors } = useMetaLayoutContext();
  const { footerRef } = useFooterContext();
  const { handleSubmit } = useNewLoginContext();
  const [isSubmitting, setIsSubmitting] = useState(false);

  const onFormSubmit = async () => {
    setIsSubmitting(true);
    const coll = await onSubmit();
    if (coll) {
      handleSubmit(coll);
    }
    setIsSubmitting(false);
  };

  return (
    <BaseFormLayout
      className={classes.root}
      onSubmit={onFormSubmit}
      errors={unsourcedErrors}
      message={resource.attr('message')}
    >

      {/* ****** REMAINING META-FIELDS WILL RENDER HERE ****** */}
      <RemainingFieldList />

      {/* ---- Footer / Actions (Portal)---- */}
      <Portal container={footerRef.current}>

        {/* ---- Submit Button ---- */}
        <RoundedButton
          disableElevation
          disabled={isSubmitting}
          variant={'contained'}
          color={'primary'}
          onClick={onFormSubmit}
          fullWidth
          test={'authentication-default-layout-submit-button'}
        >
          {'Submit'}
        </RoundedButton>
      </Portal>
    </BaseFormLayout>
  );
}

DefaultLayout.propTypes = {
  classes: PropTypes.object.isRequired,
};

DefaultLayout.defaultProps = {
};

export default withStyles(styles)(DefaultLayout);
